import { PlaceholderPage } from '../_PlaceholderPage';
export function Auditoria() {
  return <PlaceholderPage title="Auditoría" description="Listado de eventos con filtros por tipo, usuario, fecha y DeCA. Exportación a CSV." />;
}
